(()=>{
  let scrollY=0;
  let activeTrigger=null;
  const modal=()=>document.querySelector('[data-cozy-review-lightbox]');
  const image=()=>modal()?.querySelector('[data-cozy-review-lightbox-image]');

  function lockPage(){
    scrollY=window.scrollY;
    document.body.style.position='fixed';
    document.body.style.top=`-${scrollY}px`;
    document.body.style.left='0';
    document.body.style.right='0';
    document.body.style.width='100%';
  }

  function unlockPage(){
    document.body.style.position='';
    document.body.style.top='';
    document.body.style.left='';
    document.body.style.right='';
    document.body.style.width='';
    window.scrollTo(0, scrollY);
  }

  function open(trigger){
    const lightbox=modal();
    const target=image();
    if(!lightbox||!target)return;
    activeTrigger=trigger;
    target.src=trigger.dataset.imageSrc||trigger.querySelector('img')?.src||'';
    target.alt=trigger.querySelector('img')?.alt||'';
    lockPage();
    lightbox.hidden=false;
    lightbox.querySelector('[data-cozy-review-lightbox-close]')?.focus();
  }

  function close(){
    const lightbox=modal();
    if(!lightbox||lightbox.hidden)return;
    lightbox.hidden=true;
    const target=image();
    if(target)target.removeAttribute('src');
    unlockPage();
    activeTrigger?.focus({ preventScroll: true });
    activeTrigger=null;
  }

  document.addEventListener('click',(event)=>{
    const trigger=event.target.closest?.('[data-cozy-review-photo]');
    if(trigger){event.preventDefault();open(trigger);return;}
    const closeButton=event.target.closest?.('[data-cozy-review-lightbox-close]');
    const lightbox=event.target.closest?.('[data-cozy-review-lightbox]');
    if(closeButton||(lightbox&&event.target===lightbox))close();
  });

  document.addEventListener('keydown',(event)=>{
    if(event.key==='Escape'&&!modal()?.hidden){event.preventDefault();close();}
  });
})();
